// extracted by mini-css-extract-plugin
module.exports = {"rankingCardBody":"RankingCardBody_rankingCardBody__cVZne","order":"RankingCardBody_order__3jShJ","lastRowItem":"RankingCardBody_lastRowItem__2hSlJ"};